import React from "react";

import "./styles.scss";

/*Card for Student Testemonial*/
function Card5({ name, description, link }) {
  return (
    <div className="card-type5-section student-section">
      
   
      <div className="type2-info">
        <div className="name">{name}</div>
        <div className="type2-description1">{description}</div>
        <div className="dbb-program-card-btn">
          <a
            target="_blank"
            rel="noreferrer"
            href={link}
          >
          Explore Program
          </a>
        </div>
      </div>
    </div>
  
  );
}

export default Card5;
